import { Typography } from '@components';
import { Link } from 'gatsby';
import React from 'react';
import { Archive, Delete, Trello } from 'react-feather';

interface Props {
  name: string;
  serial: string;
  rmm?: number;
  invoice?: string;
  invoiceDate?: string;
  showHistory?: any;
}

export const AssetHeader = ({
  name,
  serial,
  rmm,
  invoice,
  invoiceDate,
  showHistory,
}: Props) => {
  const iconSize = 18;
  return (
    <div className="grid grid-cols-4 border border-gray-200 rounded-lg mb-4">
      <div className="border-r border-gray-200 p-2 flex flex-col justify-center">
        <Typography tag="p" type="labelSemiBold">
          {name}
        </Typography>
        <Typography tag="label" type="label">
          SN: {serial}
        </Typography>
      </div>

      <div className="border-r border-gray-200 p-2 flex flex-col justify-center">
        <Typography tag="p" type="labelSemiBold">
          RMM
        </Typography>
        <Typography tag="label" type="label">
          {rmm ? rmm : 'NA'}
        </Typography>
      </div>
      <div className="border-r border-gray-200 p-2 flex flex-col justify-center">
        <Typography tag="p" type="labelSemiBold">
          Factuur: {invoice ? invoice : '/'}
        </Typography>
        <Typography tag="label" type="label">
          {invoice ? invoiceDate : 'NA'}
        </Typography>
      </div>

      <div className="border-r border-gray-200 p-2 flex flex-col">
        <div className="flex justify-between justify-center mt-2">
          <div className="flex gap-4">
            <Archive
              className="text-blue-500"
              size={iconSize}
              onClick={showHistory}
            />
            <Link
              to={`https://cmc.rmmservice.eu/#/deviceDashboard/${rmm}/overview`}
              target="_blank"
            >
              <Trello className="text-blue-500 pointer" size={iconSize} />
            </Link>
          </div>
          <Delete className="text-red-500" size={iconSize} />
        </div>
      </div>
    </div>
  );
};

export default AssetHeader;
